import React from "react";
import ReactWOW from "react-wow";
import { $t } from '@/modules/i18n';
const LogoCard = ({ logo = {} }) => {
  const { link, colorImg, grayImg, title, desc } = logo;
  const jump = (url) => {
    if (!url) {
      return;
    }
    window.location.href(url);
  }
  return (
    <>
      <ReactWOW animation="fadeInUp" delay="0.1s">
        <div
          onClick={jump(link)}
          className="logo-item-link"
        >
          <div className="logo-img">
            <img src={colorImg} alt={$t(title)} className="color-logo" />
            <img src={grayImg} alt={$t(title)} className="gray-img-logo" />
          </div>
          <p className="title">{$t(title)}</p>
          <div className="desc-wrapper">
            {
              Array.isArray(desc)
                ? desc.map(desc => <p className="desc" key={desc}>{$t(desc)}<span>,</span></p>)
                : <p className="desc">{$t(desc)}</p>
            }
          </div>
        </div>
      </ReactWOW>
    </>
  )
}

const Offices = ({ message }) => {
  return message ? (
    <div className="offices-wrapper">
      <p className="offices-desc">{$t(message.desc)}</p>
      <div className="content">
        {
          message.list.map((logo) => (
            <LogoCard
              key={logo.title}
              logo={logo}
            />
          ))
        }
      </div>
    </div >
  ) : null;
}

export default Offices;
